"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var cell_style_merger_1 = require("../merger/cell-style-merger");
/**
 * Resolve conditional styles
 *
 * Created by Hayk.Andriasyan on 4/18/2018.
 */
var CellConditionalFormattingStyleResolver = /** @class */ (function () {
    function CellConditionalFormattingStyleResolver(_reportViewStyles) {
        this._reportViewStyles = _reportViewStyles;
    }
    /**
     * Resolve conditional styles, if there is both row and column styles on the same cell, column conditional styles takes the precedence.
     * If cellIndex is not given (null or undefined) column styles are not going to by applied
     */
    CellConditionalFormattingStyleResolver.prototype.resolveValueCellStyle = function (rowBranchIndex, rowCategoryPathHolderId, columnBranchIndex, rowValues, cellIndex, leafsIndexToMeasureMetadataMap) {
        var styles = [];
        var rowFormattingStyle = this.resolveRowConditionalFormattingStyle(rowBranchIndex, rowCategoryPathHolderId, rowValues);
        if (rowFormattingStyle) {
            styles.push(rowFormattingStyle);
        }
        if (typeof cellIndex !== 'undefined' && cellIndex !== null) {
            var columnFormattingStyle = this.resolveColumnConditionalFormattingStyle(rowValues[cellIndex], columnBranchIndex, leafsIndexToMeasureMetadataMap);
            if (columnFormattingStyle) {
                styles.push(columnFormattingStyle);
            }
        }
        return cell_style_merger_1.CellStyleMerger.mergeTextStyles(styles);
    };
    /**
     * Get tabular report's first row category column's style if corresponding row has an row formatting style
     */
    CellConditionalFormattingStyleResolver.prototype.resolveRowCategoryItemStyle = function (rowBranchIndex, rowCategoryPathHolderId, rowValues) {
        return this.resolveValueCellStyle(rowBranchIndex, rowCategoryPathHolderId, null, rowValues, null, null);
    };
    CellConditionalFormattingStyleResolver.prototype.resolveValueCellStyleWithoutRowGrouping = function (columnBranchIndex, rowValue, leafsIndexToMeasureMetadataMap) {
        return this.resolveColumnConditionalFormattingStyle(rowValue, columnBranchIndex, leafsIndexToMeasureMetadataMap);
    };
    CellConditionalFormattingStyleResolver.prototype.resolveRowConditionalFormattingStyle = function (rowBranchIndex, rowCategoryPathHolderId, rowValues) {
        // rowBranch index can be undefined if there is no row category
        return (rowBranchIndex !== null && rowBranchIndex !== undefined) &&
            this._reportViewStyles.rowBranchStylesDto &&
            this._reportViewStyles.rowBranchStylesDto[rowBranchIndex] &&
            this._reportViewStyles.rowBranchStylesDto[rowBranchIndex].categoriesStyle &&
            this._reportViewStyles.rowBranchStylesDto[rowBranchIndex].categoriesStyle.get(rowCategoryPathHolderId) &&
            this._reportViewStyles.rowBranchStylesDto[rowBranchIndex].categoriesStyle.get(rowCategoryPathHolderId).rowFormattingRule.getRowFormat(rowValues);
    };
    CellConditionalFormattingStyleResolver.prototype.resolveColumnConditionalFormattingStyle = function (rowValue, columnBranchIndex, leafsIndexToMeasureMetadataMap) {
        // cell's value can be empty, we don't need to apply style on that cell
        if (rowValue !== '') {
            return this._reportViewStyles.columnBranchStylesDto &&
                this._reportViewStyles.columnBranchStylesDto[leafsIndexToMeasureMetadataMap.get(columnBranchIndex)] &&
                this._reportViewStyles.columnBranchStylesDto[leafsIndexToMeasureMetadataMap.get(columnBranchIndex)].measureStyle &&
                this._reportViewStyles.columnBranchStylesDto[leafsIndexToMeasureMetadataMap.get(columnBranchIndex)].measureStyle.columnFormattingRule.getColumnFormat(rowValue);
        }
    };
    return CellConditionalFormattingStyleResolver;
}());
exports.CellConditionalFormattingStyleResolver = CellConditionalFormattingStyleResolver;
//# sourceMappingURL=cell-conditional-formatting-resolver.js.map